<template>
  <el-popover
    placement="bottom-end"
    v-model="showPopover"
    popper-class="popper-clear-style"
    trigger="click"
  >
    <div class="container">
      <div class="el-icon-loading" v-if="isCheckingBlack"></div>
      <div class="btn-contaniner" v-else>
        <div v-if="conversationID" class="pointer" @click.stop="deleteConversation">
          刪除
        </div>
        <div v-if="canImpeach" class="pointer" @click.stop="showImpeach">
          檢舉
        </div>
        <div v-if="canImpeach&&hasBlock" class="pointer" @click.stop="handleBlack">
          <i v-if="isHandlingBlack" class="el-icon-loading"></i>
          <p v-else>{{ isBlack ? '解除封鎖' : '封鎖' }}</p>
        </div>
      </div>
    </div>
    <button
      class="cirle-container"
      slot="reference"
      :style="{ width, height }"
    >
      <fps-icon class="more-icon" type="more" size="24" />
    </button>
  </el-popover>
</template>
<script>
import impeach from '@/components/Impeach/index.js';
import { checkBlack } from '@/api';
import { mapGetters } from 'vuex'
export default {
  name: 'UserRelation',
  props: {
    currentMasterId: {
      type: String,
      required: true,
    },
    width: {
      type: String,
      default: '44px',
    },
    height: {
      type: String,
      default: '44px',
    },
    conversationID: {
      type: String,
      default: '',
    },
    hasBlock: {
      type: Boolean,
      default: true
    },
    defaultReason: {
      type: Array,
      default: ()=>{
        return [
          '發送虛假與有害信息騷擾用戶',
          '虛假個人資料',
          '利用違規手段下單或接單',
          '陪玩師不接單',
          '發布違規約單內容',
          '惡意刷單',
          '其他違規行為',
        ]
      }
    }
  },
  data() {
    return {
      showPopover: false,
      isBlack: false,
      isHandlingBlack: false,
      isCheckingBlack: false,
    };
  },
  watch: {
    showPopover(newVal) {
      if (newVal) {
        this.isCheckingBlack = true;
        document.addEventListener('click', this.closePopover, true)
        checkBlack({
          uuid: this.currentMasterId,
        })
          .then(({ data }) => {
            this.isCheckingBlack = false;
            this.isBlack = data;
          })
          .catch(() => {
            this.isCheckingBlack = false;
          });
      } else {
        document.removeEventListener('click', this.closePopover, true)
      }
      this.$emit('menuSwitch', newVal)
    },
  },
  computed: {
    ...mapGetters(['userInfo']),
    cannotImpeach() {
      return ['fpx666', this.$store.state.app.adminUuid, ...this.$store.state.app.systemUuid]
    },
    canImpeach() {
      return !this.cannotImpeach.some((id) => id === this.currentMasterId);
    },
  },
  methods: {
    closePopover() {
      this.showPopover = false
      document.removeEventListener('click', this.closePopover, true)
    },
    handleBlack() {
      this.isHandlingBlack = true;
      if (!this.isBlack) {
        this.$http.post('/user/black/active', {
          blackUuid: this.currentMasterId,
        })
          .then(() => {
            this.isHandlingBlack = false;
            this.isBlack = !this.isBlack;
          })
          .catch(() => {
            this.isHandlingBlack = false;
            this.$message.error('操作失敗');
          });
      } else {
        this.$http.post('/user/black/inactive', {
          blackUuid: this.currentMasterId,
        })
          .then(() => {
            this.isHandlingBlack = false;
            this.isBlack = !this.isBlack;
          })
          .catch(() => {
            this.isHandlingBlack = false;
            this.$message.error('操作失敗');
          });
      }
    },
    showImpeach() {
      this.showPopover = false;
      if (this.userInfo) {
        impeach({
          reportedId: this.currentMasterId,
          defaultReason: this.defaultReason
        });
      } else {
        this.$util.Login();
      }
    },
    /**
     * @description 刪除會話，但是消息紀錄會保存
     */
    deleteConversation() {
      this.$store.dispatch('im/deleteConversation', this.conversationID)
    },
  },
};
</script>
<style lang="scss" scoped>
.pointer {
  cursor: pointer;
}
.cirle-container {
  @include flex(center);
  .more-icon {
    color: $color-gray-2;
  }
}
.container {
  width: 88px;
  color: #333;
  font-size: 14px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 2px 4px 24px rgba(17, 17, 53, 0.0773601);
  display: flex;
  justify-content: center;
  align-items: center;
  .btn-contaniner {
    background: #fff;
    padding: 8px;
    border-radius: 4px;
    div {
      width: 72px;
      height: 32px;
      line-height: 32px;
      text-align: left;
      border-radius: 4px;
      padding-left: 8px;
      &:hover {
        background: $color-split;
      }
    }
  }
}
</style>